import { TableColumn } from '../../types/commonTypes';
import { Checkbox, Radio, TableSortLabel, Tooltip } from '@material-ui/core';
import clsx from 'clsx';

interface Props {
  classes: {
    cell: string;
    center: string;
    header: string;
    row: string;
  };
  columns: TableColumn[];
  displayDataCount: number;
  loading: boolean;
  multiSelect?: boolean;
  onSelectAll(selectAll: boolean): void;
  onSort: (dataKey: string) => void;
  selectAllItems?: boolean;
  selectedIndexes?: number[];
  singleSelect?: boolean;
  sortAsc: boolean;
  sortColumn: string;
}

export const HeaderRow = (props: Props) => {
  const {
    classes,
    columns,
    displayDataCount,
    loading,
    multiSelect = false,
    onSelectAll,
    onSort,
    selectAllItems = false,
    singleSelect = false,
    sortAsc,
    sortColumn,
  } = props;

  return (
    <tr className={`${classes.header} ${classes.row}`}>
      {multiSelect ? (
        <th className={`${classes.cell} ${classes.center}`}>
          <Checkbox
            className="z-10"
            disabled={loading}
            checked={selectAllItems}
            color="primary"
            size="small"
            onChange={(event) => {
              event.preventDefault();
              event.stopPropagation();
              onSelectAll(event.target.checked);
            }}
          />
        </th>
      ) : singleSelect ? (
        <th className={`${classes.cell} ${classes.center}`}>
          <Radio
            disabled={loading}
            checked={false}
            color="primary"
            style={{ visibility: 'hidden' }}
          />
        </th>
      ) : null}
      {columns
        .filter((c) => !c.isHidden)
        .map((c) => (
          <th
            className={clsx(`${classes.cell} ${classes.center} z-10`, {
              'sticky bg-card-dark text-white': c.sticky !== undefined,
              'left-0': c.sticky && c.sticky === 'left',
              'right-0': c.sticky && c.sticky === 'right',
            })}
            key={c.name}
          >
            <Tooltip
              title="Sort"
              placement={'bottom-start'}
              arrow
              enterDelay={300}
            >
              <TableSortLabel
                className="hover:!text-white/70"
                disabled={loading || !(c.canSort ?? true)}
                active={c.dataKey === sortColumn}
                direction={sortAsc ? 'asc' : 'desc'}
                onClick={() => onSort(c.dataKey)}
                hideSortIcon={c.canSort ?? false}
              >
                {c.name}
              </TableSortLabel>
            </Tooltip>
          </th>
        ))}
    </tr>
  );
};
